import styled from 'styled-components';
import { Flex } from '../../../../GlobalComponents/Flex';
import Button from '../../../../GlobalComponents/Button';

export const FavoriteProduct = ({
	id,
	name,
	icon,
	isAvailable,
	isStoreGlobal,
	onClick
}: ProductProps): JSX.Element => {
	return (
		<Flex
			$flexDirection="row"
			style={{ borderBottom: '1px solid rgba(87,87,87,0.25)' }}
			$padding={'0 0 24px 0'}
			$alignItems={'center'}
			$justifyContent="space-between"
		>
			<Flex $alignItems="center" $width="60%">
				<Image src={icon} />
				<Name>{name}</Name>
			</Flex>
			<Button
				onClick={() => {
					onClick?.(id, isAvailable);
				}}
				disabled={!isStoreGlobal && !isAvailable}
			>
				{isStoreGlobal
					? 'SELECT STORE'
					: isAvailable
						? 'ORDER AGAIN'
						: 'UNAVAILABLE'}
			</Button>
		</Flex>
	);
};

const Image = styled.img`
	width: 60px;
	height: 60px;
	object-fit: contain;
	margin-right: 16px;
	border: 1px solid #f47920;
	border-radius: 50%;

	@media (max-width: 600px) {
		width: 50px;
		height: 50px;
		margin-right: 12px;
	}
`;

const Name = styled.span`
	font-weight: 700;
	font-size: 20px;
	color: #575757;
	line-height: 100%;
	@media (max-width: 600px) {
		font-size: 18px;
	}
`;

export interface ProductProps {
	id: string;
	name: string;
	icon: string;
	isAvailable: boolean;
	isStoreGlobal: boolean;

	onClick?: (id: string, isAvailable: boolean) => void;
}
